// Database Access Object
export default {
  async getCollectionFromFireStore(db, collectionName) {
    let wines = await db.collection(collectionName).get();
    return wines;
  },

  async getLimitCollectionFromFireStore(db, collectionName, limit) {
    let wines = await db
      .collection(collectionName)
      .limit(limit)
      .get();
    return wines;
  },

  async getPaginationData(db, collectionName, limit, startAfter) {
    let wines = await db
      .collection(collectionName)
      .startAfter(startAfter)
      .limit(limit)
      .get();
    return wines;
  },

  async getDocumentFromFireStore(db, collectionName, documentId) {
    let document = await db
      .collection(collectionName)
      .doc(documentId)
      .get();
    if (document.exists) {
      return document.data();
    } else {
      return undefined;
    }
  },

  async addAutoDocumentToFireStore(db, collectionName, data) {
    return await db.collection(collectionName).add(data);
  },

  async deleteDocumentInFireStore(db, collectionName, documentId) {
    await db
      .collection(collectionName)
      .doc(documentId)
      .delete();
  },

  async updateDocumentInFireStore(db, collectionName, documentId, data) {
    let update = await db.collection(collectionName);
    update.doc(documentId).update(data);
  }
};
